<template>
  <v-fade-transition v-if="loading">
    <v-overlay :absolute="absolute" color="white" opacity="0.7">
      <v-progress-circular indeterminate color="primary"></v-progress-circular
    ></v-overlay>
  </v-fade-transition>
</template>

<script>
export default {
  name: 'ElOverlayLoading',
  props: {
    loading: Boolean,
    absolute: { type: Boolean, default: true },
  },
}
</script>

<style lang="scss" scoped></style>
